import styled, { css } from 'styled-components';
import Button from '@/trio-ui/Button';

export const AddReviewerForm = styled.div<{ isOpened?: boolean }>`
  width: 344px;
  background: #ffffff;
  position: fixed;
  top: 56px;
  right: 0;
  z-index: 9;
  height: calc(100% - 56px);
  box-shadow: -10px 10px 12px 6px rgba(0, 0, 0, 0.07);
  transition: translate 0.3s ease;
  translate: ${(props) => (props.isOpened ? '0px 0px;' : '360px 0px')};
`;

export const FormContainer = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const FormHeader = styled.div`
  margin-bottom: 24px;
  flex-shrink: 0;

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #2d3748;
  }
`;

export const FormContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 0;
  overflow: hidden;
`;

export const FormField = styled.div<{ hasScroll?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${({ hasScroll }) =>
    hasScroll &&
    css`
      overflow: auto;
    `}

  label {
    font-size: 14px;
    font-weight: 500;
    color: #4a5568;
  }

  select {
    padding: 8px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    font-size: 14px;
    background: white;

    &:focus {
      outline: none;
      border-color: #054ad9;
      box-shadow: 0 0 0 1px #054ad9;
    }
  }
`;

export const DisabledMessage = styled.div`
  padding: 12px;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 12px;
  color: #718096;
  font-style: italic;
`;

export const SkillsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 8px;
  background: #f7fafc;
  overflow: auto;
`;

export const SkillsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  overflow: auto;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const SkillRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  border-radius: 3px;
  background: white;
  border: 1px solid #e2e8f0;

  &:not(:last-child) {
    border-bottom: 1px solid #e2e8f0;
  }

  &:hover {
    background: #f8fafc;
  }
`;

export const SkillRowTop = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SkillRowBottom = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 4px;
`;

export const SkillSelect = styled.select`
  flex: 1;
  min-width: 120px;
  padding: 4px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 3px;
  font-size: 13px;
  background: white;

  &:focus {
    outline: none;
    border-color: #054ad9;
    box-shadow: 0 0 0 1px #054ad9;
  }
`;

export const RemoveSkillButton = styled.button`
  padding: 2px;
  min-width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #e53e3e;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(229, 62, 62, 0.1);
    color: #e53e3e;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(229, 62, 62, 0.2);
  }
`;

export const WillingToReviewToggle = styled.input`
  margin: 0;
  transform: scale(0.9);
`;

export const AddSkillButton = styled(Button)`
  width: 100%;
  margin-top: 4px;
  padding: 6px 12px;
  font-size: 12px;
  flex-shrink: 0;
`;

export const FormFooter = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  flex-shrink: 0;
`;

export const SubmitButton = styled.button`
  padding: 8px 16px;
  background: #054ad9;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #0439b3;
  }

  &:disabled {
    background: #cbd5e0;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled.button`
  padding: 8px 16px;
  background: white;
  color: #4a5568;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #f7fafc;
  }
`;

export const SearchResults = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
`;

export const SearchResultItem = styled.div`
  padding: 12px;
  cursor: pointer;
  border-bottom: 1px solid #f7fafc;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f7fafc;
  }
`;
